<style scoped lang="scss">
  @import "../user";
</style>
<style scoped>
.last1{
  display: block;
}
.last{
  display: none;
}
@media screen and (max-width: 640px){
  .last1{
    display: none!important;
  }
  .last{
    display: block!important;
  }
  h3{
    font-size: 20px!important;
  }
}
</style>
<template>
  <div class="user">
    <section>
      <h3 class="title">测序取样申请记录</h3>
      <el-button type="primary" class="last1" @click="$router.push('/tec/order_sanger')">发起取样</el-button>
      <el-button type="primary" size="mini" class="last" @click="$router.push('/tec/order_sanger')">发起取样</el-button>
      <el-table
        class="mt20"
        border
        :data="tableData">
        <el-table-column
          label="申请时间">
          <template slot-scope="scope">{{scope.row.createSendDate | rTime}}</template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
        <el-table-column
          label="附件">
          <template slot-scope="scope">
            <a href="javascript:void(0)" @click="downloadFile(scope.row)">{{scope.row.fileName}}</a>
          </template>
        </el-table-column>
      </el-table>
      <div class="page tr">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          @current-change="changePage">
        </el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import { bringOrdersLists } from '@/services/api.index'
export default {
  data() {
    return {
      tableData: [],
      total: 0,
      page: 0,
      pageSize: 10
    }
  },
  created() {
    this.getOrders()
  },
  methods: {
    getOrders () {
      const { page, pageSize } = this
      bringOrdersLists(page, pageSize).then(res => {
        this.tableData = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 附件下载
    downloadFile (item) {
      this.baseMethods.courseDownload(item.fileUrl, item.fileName)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getOrders()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/children/sanger_record.vue